import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Settings,
  Mail,
  CreditCard,
  Landmark,
  Flag,
  Globe2,
  ScrollText,
  Cpu,
  Server,
} from "lucide-react";
import { PageHeader } from "@/components/common/page-header";
import { GeneralSettingsTab } from "./GeneralSettingsTab";
import { SmtpSettingsTab } from "./SmtpSettingsTab";
import { StripeSettingsTab } from "./StripeSettingsTab";
import { BankTransferSettingsTab } from "./BankTransferSettingsTab";
import { FeatureFlagsTab } from "./FeatureFlagsTab";
import { AgreementsTab } from "./AgreementsTab";
import { VmCpuLimitCard } from "./VmCpuLimitCard";
import { VmSettingsTab } from "./VmSettingsTab";

export function PlatformSettingsListPage() {
  const [activeTab, setActiveTab] = useState("general");

  return (
    <div className="flex h-full min-h-0 flex-col space-y-5">
      {/* PageHeader takes no className, so the wrapper is what keeps it from being squeezed
          by the height-bounded tab content below it. */}
      <div className="shrink-0">
        <PageHeader
          title="Platform Settings"
          subtitle="Manage global configuration, payment methods, email delivery, and client capabilities."
          leading={
            <div className="hidden size-10 items-center justify-center rounded bg-primary/10 text-primary sm:flex">
              <Globe2 className="size-5" />
            </div>
          }
        />
      </div>

      <Tabs
        value={activeTab}
        onValueChange={setActiveTab}
        className="flex min-h-0 flex-1 flex-col"
      >
        <div className="-mx-1 shrink-0 overflow-x-auto border-b px-1 pb-3">
          <TabsList className="h-11 w-max rounded border bg-muted/70 p-1 shadow-sm">
            <TabsTrigger
              value="general"
              className="gap-2 rounded-lg px-4 hover:bg-background/70 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm"
            >
              <Settings className="h-4 w-4" />
              General
            </TabsTrigger>
            <TabsTrigger
              value="smtp"
              className="gap-2 rounded-lg px-4 hover:bg-background/70 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm"
            >
              <Mail className="h-4 w-4" />
              SMTP Settings
            </TabsTrigger>
            <TabsTrigger
              value="stripe"
              className="gap-2 rounded-lg px-4 hover:bg-background/70 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm"
            >
              <CreditCard className="h-4 w-4" />
              Stripe
            </TabsTrigger>
            <TabsTrigger
              value="bank-transfer"
              className="gap-2 rounded-lg px-4 hover:bg-background/70 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm"
            >
              <Landmark className="h-4 w-4" />
              Bank Transfer
            </TabsTrigger>
            <TabsTrigger
              value="feature-flags"
              className="gap-2 rounded-lg px-4 hover:bg-background/70 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm"
            >
              <Flag className="h-4 w-4" />
              Feature Flags
            </TabsTrigger>
            <TabsTrigger
              value="agreements"
              className="gap-2 rounded-lg px-4 hover:bg-background/70 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm"
            >
              <ScrollText className="h-4 w-4" />
              Agreements
            </TabsTrigger>
            <TabsTrigger
              value="vm"
              className="gap-2 rounded-lg px-4 hover:bg-background/70 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm"
            >
              <Server className="h-4 w-4" />
              VM
            </TabsTrigger>
            <TabsTrigger
              value="cpu-limit"
              className="gap-2 rounded-lg px-4 hover:bg-background/70 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm"
            >
              <Cpu className="h-4 w-4" />
              CPU Limit
            </TabsTrigger>
          </TabsList>
        </div>
        <TabsContent
          value="general"
          className="mt-5 flex min-h-0 flex-1 flex-col"
        >
          <GeneralSettingsTab />
        </TabsContent>
        <TabsContent value="smtp" className="mt-5">
          <SmtpSettingsTab />
        </TabsContent>
        <TabsContent value="stripe" className="mt-5">
          <StripeSettingsTab />
        </TabsContent>
        <TabsContent value="bank-transfer" className="mt-5">
          <BankTransferSettingsTab />
        </TabsContent>
        <TabsContent value="feature-flags" className="mt-5">
          <FeatureFlagsTab />
        </TabsContent>
        <TabsContent value="agreements" className="mt-5">
          <AgreementsTab />
        </TabsContent>
        <TabsContent value="vm" className="mt-5">
          <VmSettingsTab />
        </TabsContent>
        <TabsContent value="cpu-limit" className="mt-5">
          <VmCpuLimitCard />
        </TabsContent>
      </Tabs>
    </div>
  );
}
